import type { HttpMock } from '#e2e-utils/mockScenarios';

export const missingRightsMock: HttpMock[] = [
  {
    request: {
      method: 'POST',
      urlPathPattern: '^/v3/permissions/actions/search',
    },
    response: {
      status: 200,
      body: [],
    },
  },
];
